<template>
  <v-icon
    :color="iconColor"
    v-on="$listeners"
    v-bind="{ ...$attrs, ...$props }"
    :size="size"
    :disabled="disabled"
    class="admin-checkbox"
    >{{ iconName }}</v-icon
  >
</template>

<script>
export default {
  name: 'AdminInputCheckbox',
  props: {
    on: {
      type: Boolean,
      require: true,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'large',
    },
  },
  computed: {
    iconColor() {
      return this.on ? 'green' : 'grey lighten-2'
    },
    iconName() {
      return this.on ? 'mdi-check' : 'mdi-square-outline'
    },
  },
  data() {
    return {}
  },
}
</script>

<style>
.admin-list-checkbox {
  cursor: pointer;
}
</style>
